import type { FaireThemeEntity } from "../../entity_types/theme";

export const modern_vintage_and_charms: FaireThemeEntity = {
  token: "modern-vintage-and-charms",
  type: "theme",
  name: "Modern Vintage & Charms",
  description: "Jewelry with symbolic motifs like the Evil Eye and classic vintage silhouettes.",
  teaser: "Unique, giftable designs with character -- perfect impulse buys.",
  detail: "Perfect impulse buys for brick-and-mortar. Built around the Evil Eye adjustable ring and vintage gold oval watch recently added to your cart -- retro-inspired designs with a personal touch.",
  bgColor: "#D4EBD4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ut3tbs6mrw",
    "p_3pcekmbkc4",
    "p_m8ybpjvqmq",
    "p_tpf2apke3k",
    "p_zxurf3jtrh",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
